import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import HeroLicenciatura from "../components/TopPage";

export default function Convenios() {
  const navigate = useNavigate();

  return (
    <div className="app-root" style={{ position: "relative" }}>
      <Navbar />
      <main style={{ position: "relative", zIndex: 1 }}>
        <HeroLicenciatura
          title="NUESTROS"
          highlight="CONVENIOS."
          subtitle=""
          cct=""
        />
      </main>

      <section
        style={{
          width: "100%",
          background: "#fff",
          padding: "clamp(26px, 4vw, 56px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          {/* ✅ Quitamos el maxWidth que limitaba el texto */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                fontSize: "0.95rem",
                letterSpacing: "0.08em",
                fontWeight: 700,
                color: "#f4a640",
                textTransform: "uppercase",
                marginBottom: 6,
              }}
            >
              EMPRESAS
            </div>

            <h2
              style={{
                margin: "0 0 14px 0",
                fontSize: "clamp(2.1rem, 4vw, 3rem)",
                lineHeight: 1.05,
                fontWeight: 900,
                color: "#0f3b63",
              }}
            >
              VINCULADAS<span style={{ color: "#0f3b63" }}>.</span>
            </h2>

            <p
              style={{
                margin: "0 0 12px 0",
                color: "#7a8594",
                lineHeight: 1.6,
                fontSize: "1.02rem",
                width: "100%",
              }}
            >
              Nuestro compromiso es conectar a los estudiantes con las mejores
              empresas y organizaciones que participan activamente en programas
              de servicio social y prácticas profesionales.
            </p>

            <p
              style={{
                margin: "0 0 12px 0",
                color: "#7a8594",
                lineHeight: 1.6,
                fontSize: "1.02rem",
                width: "100%",
              }}
            >
              Contamos con una red sólida de empresas vinculadas que reconocen
              la importancia de formar talento joven y aportar al desarrollo
              social y económico de nuestra comunidad.
            </p>

            <p
              style={{
                margin: 0,
                color: "#7a8594",
                lineHeight: 1.6,
                fontSize: "1.02rem",
                width: "100%",
              }}
            >
              Nuestras empresas vinculadas abarcan diversos sectores como
              tecnología, marketing, salud, educación, ingeniería y servicios,
              todas comprometidas con ofrecer oportunidades reales y
              enriquecedoras para los futuros profesionales. Estas alianzas
              permiten a los estudiantes adquirir una experiencia laboral
              invaluable, mientras contribuyen con proyectos innovadores en un
              entorno laboral real y dinámico.
            </p>
          </div>
        </div>
      </section>

      <section
        style={{
          width: "100%",
          background: "#fff",
          padding: "clamp(26px, 4vw, 56px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1.25fr 0.75fr",
              gap: "clamp(18px, 3vw, 44px)",
              alignItems: "center",
            }}
          >
            {/* IZQUIERDA */}
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: "0.95rem",
                  letterSpacing: "0.08em",
                  fontWeight: 700,
                  color: "#f4a640",
                  textTransform: "uppercase",
                  marginBottom: 6,
                }}
              >
                CONECTA CON
              </div>

              <h2
                style={{
                  margin: "0 0 6px 0",
                  fontSize: "clamp(2.1rem, 4vw, 3rem)",
                  lineHeight: 1.05,
                  fontWeight: 900,
                  color: "#0f3b63",
                }}
              >
                MARKETING DIGITAL<span style={{ color: "#0f3b63" }}>.</span>
              </h2>

              <div
                style={{
                  marginBottom: 14,
                  color: "#0f3b63",
                  fontWeight: 700,
                  opacity: 0.9,
                }}
              >
                (Servicio Social y Prácticas)
              </div>

              <p
                style={{
                  margin: "0 0 12px 0",
                  color: "#7a8594",
                  lineHeight: 1.6,
                  fontSize: "1.02rem",
                }}
              >
                Convenios te brinda la oportunidad de conectar con empresas que
                ofrecen prácticas profesionales y servicio social en marketing
                digital. Participar en estas actividades te permite no solo
                aprender las mejores prácticas del sector, sino también aplicar
                tus conocimientos en proyectos concretos que tienen impacto
                real.
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#7a8594",
                  lineHeight: 1.6,
                  fontSize: "1.02rem",
                }}
              >
                A través de estas experiencias, podrás desarrollar habilidades
                en estrategias digitales, manejo de redes sociales, creación de
                contenidos, análisis de datos y mucho más. Además, te
                posicionará en el mercado laboral, dándote una ventaja
                competitiva en tu carrera profesional y abriendo puertas a
                futuras oportunidades laborales.
              </p>
            </div>

            {/* DERECHA */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                alignSelf: "stretch",
                marginBottom: "-15%",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/alumna_marketing.png`} // <-- cambia
                alt="Marketing Digital"
                style={{
                  width: "100%",
                  maxWidth: 420,
                  height: "auto",
                  display: "block",
                  objectFit: "contain",
                  objectPosition: "bottom",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          padding: "clamp(26px, 4vw, 56px) 0",
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/fondo_beneficios.png)`, // <-- cambia
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay azul */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(rgb(15, 50, 90))",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          {/* Título */}
          <div style={{ marginBottom: 18 }}>
            <h2
              style={{
                margin: 0,
                fontSize: "clamp(2.1rem, 4vw, 3.2rem)",
                fontWeight: 900,
                color: "#ffffff",
                textTransform: "uppercase",
                lineHeight: 1.05,
              }}
            >
              BENEFICIOS<span style={{ color: "#ffffff" }}>.</span>
            </h2>

            <div
              style={{
                marginTop: 6,
                fontSize: "0.95rem",
                letterSpacing: "0.06em",
                fontWeight: 700,
                color: "#f4a640",
                textTransform: "uppercase",
              }}
            >
              ¿POR QUÉ PARTICIPAR EN CONVENIOS?
            </div>
          </div>

          {/* Cards naranjas */}
          <div style={{ display: "grid", gap: "clamp(14px, 2.2vw, 18px)" }}>
            {/* Card 1 */}
            <div
              style={{
                background: "#f4a640",
                borderRadius: 12,
                padding: "clamp(14px, 2.2vw, 20px)",
                boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  color: "#ffffff",
                  marginBottom: 10,
                }}
              >
                Para los estudiantes:
              </div>

              <ul
                style={{
                  margin: 0,
                  paddingLeft: 18,
                  color: "#1d2a35",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                <li>
                  <strong>Experiencia práctica y aplicable:</strong> Trabaja en
                  proyectos reales que complementan tu formación académica.
                </li>
                <li>
                  <strong>Desarrollo de habilidades:</strong> Potencia
                  competencias técnicas y blandas como comunicación, trabajo en
                  equipo, liderazgo y gestión de proyectos.
                </li>
                <li>
                  <strong>Networking:</strong> Conecta con profesionales del
                  sector y crea una red de contactos que te será útil a lo largo
                  de tu carrera.
                </li>
                <li>
                  <strong>Oportunidades de empleo:</strong> Algunos convenios
                  pueden traducirse en propuestas de contratación al terminar tu
                  etapa de prácticas.
                </li>
                <li>
                  <strong>Responsabilidad social:</strong> Participar en
                  programas que contribuyen a la comunidad, el sector social y
                  el bienestar social.
                </li>
              </ul>
            </div>

            {/* Card 2 */}
            <div
              style={{
                background: "#f4a640",
                borderRadius: 12,
                padding: "clamp(14px, 2.2vw, 20px)",
                boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  color: "#ffffff",
                  marginBottom: 10,
                }}
              >
                Para las empresas:
              </div>

              <ul
                style={{
                  margin: 0,
                  paddingLeft: 18,
                  color: "#1d2a35",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                <li>
                  <strong>Talento joven y fresco:</strong> Acceso a estudiantes
                  motivados para colaborar en proyectos innovadores.
                </li>
                <li>
                  <strong>Responsabilidad social:</strong> Cumple con tu
                  compromiso social colaborando en la formación de futuros
                  profesionales.
                </li>
                <li>
                  <strong>Innovación:</strong> Implementa nuevas ideas y
                  metodologías aportadas por estudiantes en formación.
                </li>
                <li>
                  <strong>Visibilidad:</strong> Fortalece tu imagen
                  institucional como empresa comprometida con la comunidad y el
                  desarrollo del talento joven.
                </li>
              </ul>
            </div>

            {/* Card 3 */}
            <div
              style={{
                background: "#f4a640",
                borderRadius: 12,
                padding: "clamp(14px, 2.2vw, 20px)",
                boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  color: "#ffffff",
                  marginBottom: 10,
                }}
              >
                Para la institución educativa:
              </div>

              <ul
                style={{
                  margin: 0,
                  paddingLeft: 18,
                  color: "#1d2a35",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                <li>
                  <strong>Fortalecimiento de alianzas:</strong> Construcción de
                  relaciones duraderas con empresas líderes.
                </li>
                <li>
                  <strong>Formación integral:</strong> Complementar la educación
                  académica con experiencia laboral real.
                </li>
                <li>
                  <strong>Impacto social:</strong> Contribuir al desarrollo
                  económico y social a través de la participación en programas
                  de responsabilidad social.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          width: "100%",
          background: "#fff",
          padding: "clamp(26px, 4vw, 56px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          {/* Encabezado */}
          <div style={{ marginBottom: "clamp(16px, 2.4vw, 22px)" }}>
            <div
              style={{
                fontSize: "0.95rem",
                letterSpacing: "0.08em",
                fontWeight: 700,
                color: "#f4a640",
                textTransform: "uppercase",
                marginBottom: 6,
              }}
            >
              PROCESOS &
            </div>

            <h2
              style={{
                margin: 0,
                fontSize: "clamp(2.1rem, 4vw, 3rem)",
                lineHeight: 1.05,
                fontWeight: 900,
                color: "#0f3b63",
                textTransform: "uppercase",
              }}
            >
              REQUISITOS<span style={{ color: "#0f3b63" }}>.</span>
            </h2>
          </div>

          {/* Contenido (2 columnas) */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: "clamp(14px, 2.6vw, 26px)",
              alignItems: "stretch",
            }}
          >
            {/* Columna: Proceso */}
            <div
              style={{
                border: "2px solid rgba(244,166,64,0.55)",
                borderRadius: 10,
                padding: "clamp(16px, 2.4vw, 22px)",
                background: "#fff",
                boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  color: "#0f3b63",
                  fontSize: "1.05rem",
                  marginBottom: 10,
                }}
              >
                Proceso:
              </div>

              <p
                style={{
                  margin: "0 0 12px 0",
                  color: "#7a8594",
                  lineHeight: 1.6,
                }}
              >
                Nuestro proceso está diseñado para facilitarte el camino y
                maximizar tu experiencia:
              </p>

              <ol
                style={{
                  margin: 0,
                  paddingLeft: 18,
                  color: "#7a8594",
                  lineHeight: 1.55,
                }}
              >
                <li style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Registro e inscripción.
                  </strong>
                  <br />
                  Los estudiantes interesados deben ingresar a nuestro portal
                  “Convenios”, completar su perfil y presentar la documentación
                  necesaria. La inscripción es sencilla y rápida.
                </li>

                <li style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Búsqueda y selección de empresas.
                  </strong>
                  <br />
                  Una vez inscritos, tendrás acceso a nuestra plataforma donde
                  podrás explorar las empresas vinculadas y sus oportunidades en
                  marketing digital y otras áreas. Selecciona la que mejor se
                  adapte a tu perfil y aspiraciones.
                </li>

                <li style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Presentación de propuesta y acuerdo.
                  </strong>
                  <br />
                  Contacta a la empresa seleccionada para presentar tu interés y
                  definir los objetivos, actividades y duración del convenio.
                  Nuestro equipo te apoya en la elaboración de tu propuesta y en
                  la negociación del acuerdo.
                </li>

                <li style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Formalización y firma del convenio.
                  </strong>
                  <br />
                  Una vez aceptada la propuesta, se firman los convenios y
                  acuerdos necesarios, asegurando la protección de ambas partes
                  y el cumplimiento de las responsabilidades.
                </li>

                <li style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Inicio de actividades.
                  </strong>
                  <br />
                  Comienza tu práctica o servicio social en un entorno
                  profesional, trabajando en proyectos reales que potenciarán tu
                  formación y experiencia.
                </li>

                <li style={{ marginBottom: 0 }}>
                  <strong style={{ color: "#0f3b63" }}>
                    Seguimiento y evaluación.
                  </strong>
                  <br />
                  Nuestro equipo realiza un seguimiento continuo del desempeño,
                  brindando apoyo y asesoría para garantizar una experiencia
                  enriquecedora y exitosa.
                </li>
              </ol>
            </div>

            {/* Columna: Requisitos */}
            <div
              style={{
                border: "2px solid rgba(244,166,64,0.55)",
                borderRadius: 10,
                padding: "clamp(16px, 2.4vw, 22px)",
                background: "#fff",
                boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  color: "#0f3b63",
                  fontSize: "1.05rem",
                }}
              >
                Requisitos:
              </div>

              <div style={{ display: "grid", gap: 10 }}>
                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  🧾{" "}
                  <strong style={{ color: "#0f3b63" }}>
                    Créditos aprobados:
                  </strong>{" "}
                  Tener al menos el 70% de créditos de tu carrera, o menos si lo
                  autoriza la unidad académica.
                </div>

                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  📝{" "}
                  <strong style={{ color: "#0f3b63" }}>
                    Registro y autorización:
                  </strong>{" "}
                  Registrarte y obtener la aprobación de tu unidad académica
                  para comenzar.
                </div>

                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  ⏳{" "}
                  <strong style={{ color: "#0f3b63" }}>
                    Duración y horas:
                  </strong>{" "}
                  Realizar mínimo 6 meses y completar unas 480 horas efectivas.
                  La duración puede ser hasta 2 años.
                </div>

                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  🧩 <strong style={{ color: "#0f3b63" }}>Modalidad:</strong>{" "}
                  Participar en modalidad intrainstitucional, extrainstitucional
                  o multidisciplinaria, según corresponda.
                </div>

                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  📄{" "}
                  <strong style={{ color: "#0f3b63" }}>Documentación:</strong>{" "}
                  Enviar el Formato de Registro a través del sistema de la
                  universidad y seguir los pasos correspondientes.
                </div>

                <div style={{ color: "#7a8594", lineHeight: 1.55 }}>
                  📌 <strong style={{ color: "#0f3b63" }}>Constancia:</strong>{" "}
                  La universidad emitirá una constancia que acredita el
                  cumplimiento del servicio social.
                </div>
              </div>

              {/* Imagen abajo a la derecha */}
              <div
                style={{
                  marginTop: "auto",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "-20%",
                  marginLeft: "10%",
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/alumno_requisitos.png`} // <-- cambia
                  alt="Alumno"
                  style={{
                    width: "auto",
                    height: "auto",
                    display: "block",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{
          padding: "2.5rem 1rem",
          background: "linear-gradient(90deg,#0f3b63 0%, #0a2e53 100%)",
        }}
      >
        <div
          className="grid align-items-center"
          style={{ maxWidth: 1200, margin: "0 auto" }}
        >
          {/* Texto + botón */}
          <div
            className="col-12 md:col-7"
            style={{ color: "#fff", paddingRight: "1rem" }}
          >
            <h2
              style={{
                margin: 0,
                marginBottom: 10,
                fontWeight: 900,
                letterSpacing: ".5px",
              }}
            >
              ¿QUIERES SABER MÁS?
            </h2>
            <p style={{ marginTop: 0, opacity: 0.95 }}>
              Da click al botón para conocer más sobre la licenciatura.
            </p>

            <Button
              label="Más información"
              onClick={() => navigate("/convocatoria")}
              style={{
                background: "#F2933F",
                borderColor: "#F2933F",
                color: "#0f3b63",
                fontWeight: 700,
                borderRadius: 999,
                padding: "0.9rem 1.4rem",
              }}
            />
          </div>

          {/* Logo a la derecha */}
          <div
            className="col-12 md:col-5 flex justify-content-end"
            style={{ paddingLeft: "1rem" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo.png`} /* coloca tu logo en /public/images/md_logo.png */
              alt="Lic. en Marketing Digital UNICACH"
              style={{
                maxWidth: 280,
                width: "100%",
                height: "auto",
                filter: "drop-shadow(0 6px 16px rgba(0,0,0,.15))",
              }}
            />
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{ background: "#fff", padding: "2.5rem 1rem" }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div
            style={{
              color: "#F2933F",
              fontWeight: 800,
              letterSpacing: ".5px",
              marginBottom: 6,
            }}
          >
            NUESTRAS
          </div>
          <h2
            style={{
              color: "#0f3b63",
              fontWeight: 900,
              marginTop: 0,
              marginBottom: 24,
            }}
          >
            REDES SOCIALES
          </h2>

          <div className="grid">
            {/* Facebook */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-facebook"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Facebook
                </div>
              </a>
            </div>

            {/* Instagram */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-instagram"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Instagram
                </div>
              </a>
            </div>

            {/* YouTube */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-youtube"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Youtube
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
